// src/layouts/auth/LoginPage.jsx
import { useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import PageLayout from "examples/LayoutContainers/PageLayout";
import { supabase } from "lib/supa";

export default function LoginPage() {
  const [rememberMe, setRememberMe] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  const redirectTo =
    location.state?.from?.pathname && location.state.from.pathname !== "/login"
      ? location.state.from.pathname
      : "/crm/templates";

  const handleSetRememberMe = () => setRememberMe((v) => !v);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      // Προαιρετικά: αν θέλεις "μη θυμάσαι" να είναι session-only,
      // φρόντισε ο supabase client να φτιάχνεται με persistSession: true
      // και εδώ απλώς συνεχίζουμε το κανονικό sign-in.
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) throw error;

      // Redirect πίσω εκεί που ήταν να πάει
      navigate(redirectTo, { replace: true });
    } catch (e2) {
      setErr(e2?.message || "Αποτυχία σύνδεσης");
    } finally {
      setBusy(false);
    }
  };

  return (
    <PageLayout>
      <Card>
        <MDBox px={1} width="100%" height="100vh" mx="auto">
          <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
            <Grid item xs={11} sm={9} md={5} lg={4} xl={3} sx={{ border: 1, borderColor: "info" }}>
              <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center"
              >
                <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                  Σύνδεση
                </MDTypography>
              </MDBox>

              <MDBox pt={4} pb={3} px={3}>
                <MDBox component="form" role="form" onSubmit={handleSubmit}>
                  <MDBox mb={2}>
                    <MDInput
                      type="email"
                      label="Email"
                      fullWidth
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoFocus
                    />
                  </MDBox>

                  <MDBox mb={2}>
                    <MDInput
                      type="password"
                      label="Κωδικός"
                      fullWidth
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSubmit(e);
                      }}
                    />
                  </MDBox>

                  {err && (
                    <MDBox mt={2}>
                      <Alert severity="error">{err}</Alert>
                    </MDBox>
                  )}

                  <MDBox mt={4} mb={1}>
                    <MDButton
                      type="submit"
                      variant="gradient"
                      color="info"
                      fullWidth
                      disabled={busy}
                    >
                      {busy ? (
                        <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
                          <CircularProgress size={18} />
                          <span>Σύνδεση…</span>
                        </MDBox>
                      ) : (
                        "Συνδεση"
                      )}
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </PageLayout>
  );
}
